<template>
  <WordCloudChart
    :request-status="requestStatus"
    :data="data"
    :title="title"
    :item-id="itemId"
    :card-options="customProps"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import WordCloudChart from '@/components/cards/models/WordCloudChart';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';

export default {
  name: 'TermsWordCloudChart',
  components: {
    WordCloudChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawGraphData: {},
      customProps: {
        tooltip: {
          pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.mentions}</b><br/>',
        },
      },
    };
  },
  computed: {
    data() {
      const parsedData = [];
      const parseData = rawData => {
        rawData.forEach(({ name, data, children }) => {
          parsedData.push({
            name,
            weight: data.normalized_mentions,
            mentions: data.mentions,
          });

          if (children) {
            parseData(children);
          }
        });
      };

      if (this.rawGraphData?.children) {
        parseData(this.rawGraphData.children);
      }

      return parsedData;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'termGraph',
      })
        .then(response => {
          this.rawGraphData = response;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(() => {
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
